import React, { useState, useEffect } from "react";
import { GoogleKeys } from "../../config/google"; // Import API key from config

const LocationComponent = () => {
  const [city, setCity] = useState("Fetching...");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setLatitude(latitude);
          setLongitude(longitude);
          console.log("User Location:", latitude, longitude); // Debugging

          try {
            const response = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GoogleKeys.GOOGLE_MAPS_API_KEY}`
            );
            const data = await response.json();
            console.log("Google API Response:", data); // Debugging

            if (data.results.length > 0) {
              const address = data.results[0].address_components;
              
              // Try finding "locality" (City)
              let cityComponent = address.find((comp) =>
                comp.types.includes("locality")
              );

              // If not found, try "administrative_area_level_1" (State level city)
              if (!cityComponent) {
                cityComponent = address.find((comp) =>
                  comp.types.includes("administrative_area_level_1")
                );
              }

              setCity(cityComponent ? cityComponent.long_name : "City not found");
            } else {
              setCity("City not found");
            }
          } catch (error) {
            console.error("Error fetching location data:", error);
            setCity("Error fetching location");
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
          setCity("Location access denied");
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
      );
    } else {
      setCity("Geolocation not supported");
    }
  }, []);

  return (
    <div className="py-[200px] text-center">
      <h2 className="text-2xl font-bold">Your Current City: {city}</h2>
      {latitude && longitude && (
        <p className="text-gray-500">Lat: {latitude}, Lng: {longitude}</p>
      )}
    </div>
  );
};

export default LocationComponent;
